import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - ';

export default function AOClpImageWithTextColumns() {
  const onClickCtaButton = (event) => {
    sendGoogleEvent(
      `${EVENT_CATEGORY}Image With Text (Columns)`,
      'Click primary',
      $(event.currentTarget).text(),
      { transport: 'beacon' },
    );
  };

  const initiate = () => {
    const $ctaButton = $('.js-ao-clp-image-with-text-columns__cta');

    if ($ctaButton.length) $ctaButton.click(onClickCtaButton);
  };

  return { initiate };
}
